const SHORT_DATE = 'eee, MMM dd';
const TIME_ONLY = 'h:mm aaa';

export const DATE_FORMATS = {
    SHORT_DATE,
    TIME_ONLY,
    SHORT_DATE_WITH_TIME: `${SHORT_DATE}・${TIME_ONLY}`,
    MONTH_ONLY: 'MMMM',
} as const;
